import { render, staticRenderFns } from "./compareTable.vue?vue&type=template&id=d27d99f6&"
import script from "./compareTable.vue?vue&type=script&lang=js&"
export * from "./compareTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports